import { environment } from 'src/environments/environment';

import { AppConfig } from '../models';

export class AppConfigLoader {
  public static load(): Promise<AppConfig> {
    return fetch(`/app/@config/config.app.json?v=${environment.version}`).then((r) => r.json());
  }
}
